/**
@format
@flow
*/
import React from 'react';
import styled from 'styled-components';
import ListItem from '@ziynx/components/listItems';
import type { ListItemIcon as ListItemIconType } from '@ziynx/flow-types/listItems';

export type Props = $ReadOnly<{|
    /**
     * Content array of object passed
     */
    content?: Array<ListItemIconType>,
    /**
     * Width of List, defaults to auto
     */
    width?: string | number,
    /**
     * MaxWidth of List
     */
    maxWidth?: string | number,
|}>;

const StyledListItem = styled(ListItem)`
    margin-bottom: 12px;
`;

const StyledList = styled.ul`
    padding: 0;
    width: ${({ width }) => width};
    ${({ maxWidth }) => maxWidth && `max-width: ${maxWidth}`};
`;

const ListIcon = (props: Props): React$Node => {
  const {
    content,
    width,
    maxWidth,
    ...rest
  } = props;

  const renderListItem = (): React$Node => {
    if (!content) return null;
    return content.map((item, index) => (

      <StyledListItem
        key={index}
        variant="icon"
        icon={item?.icon}
        label={item?.label}
        password={item?.password}
        color={item?.color}
        width={item?.width}
        maxWidth={item?.maxWidth}
        text={item?.text}
      >
        {item?.children}
      </StyledListItem>

    ));
  };

  return (
    <StyledList width={width} maxWidth={maxWidth} {...rest}>
      {renderListItem()}
    </StyledList>
  );
};

export default ListIcon;
